<template>

  <div class="confirm-register" :class="{ guest: true }">

    <header v-if="false" class="mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600">
      <div class="mdl-layout__header-row">
        <span>Confirm Email</span>
        <div class="mdl-layout-spacer"></div>
      </div>
    </header>

    <div class="mdl-card mdl-shadow--2dp" v-if="state=='loading'">
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">{{ i18n().loading.title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand loading">
        <div class="mdl-spinner mdl-js-spinner is-active"></div>
        <p>{{ i18n().loading.text }}</p>
      </div>
    </div>

    <div class="mdl-card mdl-shadow--2dp"
         v-if="state=='used' || state=='expired' || state=='done' || state=='notFound' || state=='resent'">
      <div class="mdl-card__title mdl-color--primary">
        <h2 class="mdl-card__title-text">{{ i18n()[state].title }}</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand loading">
        <p>{{ i18n()[state].text }}</p>
        <p v-if="state=='expired'"><router-link :to="{name: 'register'}">{{ i18n().registerLink }}</router-link></p>
      </div>
      <div v-if="state=='done'" class="mdl-card__actions mdl-card--border" :class="{blurred: state=='working'}">
        <button v-on:click="exit" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
          {{ i18n()[state].exitButton }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
  import api from "api"
  import i18n from "i18n"

  export default {
    name: 'confirm-register',
    data () {
      return {
        notMatch: false,
        error: null,
        state: 'loading',
        required: false,
        observable: null,
        keyState: false
      }
    },
    computed: {
      loggedIn() {
        return api.session.loggedIn
      },
      key() {
        return this.$route.params.key
      }
    },
    watch: {
      key() {
        this.readKey()
      },
      keyState(v) {
        if(this.state == 'loading') {
          if(!v) {
            this.state = 'notFound'
            return;
          }
          if(v.used) {
            this.state = 'used'
          } else if(v.expired) {
            this.state = 'expired'
          } else {
            this.state = "loading"
            api.request(["emailPassword", "finishRegister"], this.key).then(result => {
              this.state = "done"
            }).catch(error => {
              this.error = error
              this.state = "ready"
            })
          }
        }
      },
      loggedIn(v) {
      },
      resend(e) {
        e.preventDefault()

        this.state = "working"
        api.request(["emailPassword", "resendRegisterKey", this.keyState.email], this.email).then(result => {
          this.state = "resent"
        }).catch(error => {
          this.error = error
          this.state = "ready"
          if (error == 'notFound') {
            this.$refs.email.parentElement.setAttribute('class',
              this.$refs.email.parentElement.getAttribute('class') + ' is-invalid')
            this.$refs.email.focus()
          }
        })
      }
    },
    methods: {
      i18n() { return i18n().emailPassword.finishRegister },

      readKey() {
        if(this.observable) this.observable.unbindProperty(this, "keyState")
        this.state = 'loading'
        this.observable = api.observable(['emailPassword', 'emailKey', this.key])
        //this.observable.value = undefined
        this.observable.bindProperty(this, "keyState")
      },
      exit() {
        this.$router.replace({ name: 'index' })
      }
    },
    created() {
      this.readKey()
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @media screen and (max-width: 1024px) {
    .mdl-layout__header {
      display: block;
      margin-bottom: 3em;
    }
  }

  .guest.confirm-register {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../../../static/images/voleadstools2.png);
    background-position: center;
    background-size: 280%;
  }

  .mdl-card {
    width: 320px;
    margin: auto;
  }
  .guest .mdl-card__title {
    height: 110px;
    color: #fff;
    background: url(../../../static/images/voleadstools2_mid.png) 215px 5px no-repeat #241d7f;
    background-color:  #241d7f !important;
    background-size: 100px;
  }

  .guest button {
    background: #1d0585;
    color: white;
    font-weight: 300;
    float: right;
  }

  .guest button:hover {
    background: #2906bf;
    color: white;
    font-weight: 300;
  }

  .mdl-card__supporting-text {
    position: relative;
  }

  form.blurred {
    filter: blur(2px);
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .error {
    height: 3em;
    font-size: 1.23em;
    color: #d00000;
  }

  .loading {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }

  .mdl-card__actions button {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// ConfirmRegister.vue?3dba68ed